import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import LanguageSwitcher from './LanguageSwitcher';
import { companyInfo } from '../data/mock';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { language } = useLanguage();
  const t = translations[language];

  const isActive = (path) => {
    return location.pathname === path;
  };

  const servicesPath = language === 'en' ? '/services' : '/servizi';
  const aboutPath = language === 'en' ? '/about' : '/chi-siamo';
  const resourcesPath = language === 'en' ? '/resources' : '/risorse';
  const contactPath = language === 'en' ? '/contact' : '/contatti';
  const quotePath = language === 'en' ? '/quote' : '/preventivo';

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Manage body scroll when menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  // Close menu on route change
  useEffect(() => {
    closeMobileMenu();
  }, [location.pathname]);

  return (
    <header className="dark-header">
      <Link to="/" className="logo-link-header" onClick={closeMobileMenu}>
        <div className="header-logo-wrapper">
          <img 
            src="https://customer-assets-lqy194kg.emergentagent.net/job_iso-compliance-hub-8/artifacts/in3c33x5_1000035409.png" 
            alt="MCG Logo"
            className="header-logo-image"
          />
        </div>
        <div className="logo-text">{companyInfo.name}</div>
      </Link>
      
      {/* Desktop Navigation */}
      <nav className="dark-nav">
        <Link
          to="/"
          className={`dark-nav-link ${isActive('/') ? 'active' : ''}`}
        >
          {t.nav.home}
        </Link>
        <Link
          to={aboutPath}
          className={`dark-nav-link ${isActive(aboutPath) || isActive('/chi-siamo') || isActive('/about') ? 'active' : ''}`}
        >
          {t.nav.about}
        </Link>
        <Link
          to={servicesPath}
          className={`dark-nav-link ${isActive(servicesPath) || isActive('/servizi') || isActive('/services') ? 'active' : ''}`}
        >
          {t.nav.services}
        </Link>
        <Link
          to={resourcesPath}
          className={`dark-nav-link ${isActive(resourcesPath) || isActive('/risorse') || isActive('/resources') ? 'active' : ''}`}
        >
          {t.nav.resources}
        </Link>
        <Link
          to={contactPath}
          className={`dark-nav-link ${isActive(contactPath) || isActive('/contatti') || isActive('/contact') ? 'active' : ''}`}
        >
          {t.nav.contact}
        </Link>
        <LanguageSwitcher />
        <Link to={quotePath} className="btn-primary btn-header">
          {t.nav.quote}
        </Link>
      </nav>

      {/* Mobile Menu Toggle */}
      <button 
        className="mobile-menu-toggle"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label="Toggle menu"
      >
        {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Navigation */}
      <nav className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
        <Link
          to="/"
          className={`mobile-nav-link ${isActive('/') ? 'active' : ''}`}
          onClick={closeMobileMenu}
        >
          {t.nav.home}
        </Link>
        <Link
          to={aboutPath}
          className={`mobile-nav-link ${isActive(aboutPath) || isActive('/chi-siamo') || isActive('/about') ? 'active' : ''}`}
          onClick={closeMobileMenu}
        >
          {t.nav.about}
        </Link>
        <Link
          to={servicesPath}
          className={`mobile-nav-link ${isActive(servicesPath) || isActive('/servizi') || isActive('/services') ? 'active' : ''}`}
          onClick={closeMobileMenu}
        >
          {t.nav.services}
        </Link>
        <Link
          to={resourcesPath}
          className={`mobile-nav-link ${isActive(resourcesPath) || isActive('/risorse') || isActive('/resources') ? 'active' : ''}`}
          onClick={closeMobileMenu}
        >
          {t.nav.resources}
        </Link>
        <Link
          to={contactPath}
          className={`mobile-nav-link ${isActive(contactPath) || isActive('/contatti') || isActive('/contact') ? 'active' : ''}`}
          onClick={closeMobileMenu}
        >
          {t.nav.contact}
        </Link>
        
        <div className="mobile-menu-actions">
          <LanguageSwitcher />
          <Link 
            to={quotePath} 
            className="btn-primary btn-mobile-cta"
            onClick={closeMobileMenu}
          >
            {t.nav.quote}
          </Link>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="mobile-menu-overlay"
          onClick={closeMobileMenu}
        />
      )}
    </header>
  );
};

export default Header;
